// finds a url in the given text, if it exists, and returns object with parsed components... url and info
export const parseMeetingLink: (link: string) => {url: string; info: string} = (
  link: string,
) => {
  if (!link || link.length === 0) {
    return {url: '', info: ''};
  }

  const urlMatch = link.match(/https?:\/\/[^\s]+/);

  return {
    url: urlMatch?.[0] ?? '',
    info: !!urlMatch ? link.replace(urlMatch[0], '').trim() : link,
  };
};
